import { createFileRoute } from '@tanstack/react-router';
import { Helmet } from 'react-helmet-async';
import { ProgramChipsPage } from '@/features/agency/counter-stands/program/program-chips-page';
import { formatDocumentTitle } from '@/lib/document-title';

/** `?salon=` (a salon's short code) picks that salon: the "Program a new chip" link on a salon's agency page. */
type ProgramChipsSearchParams = {
  salon?: string;
};

/** Agency ADMIN only: members are sent back to the salons list, and the API refuses them a programming ticket. */
export const Route = createFileRoute('/_auth/agency/counter-stands/program')({
  validateSearch: (search: Record<string, unknown>): ProgramChipsSearchParams => {
    const salon = typeof search.salon === 'string' || typeof search.salon === 'number' ? String(search.salon).trim() : '';
    return salon ? { salon } : {};
  },
  component: ProgramChipsRoute,
});

function ProgramChipsRoute() {
  const { salon } = Route.useSearch();
  return (
    <>
      <Helmet defer={false}>
        <title>{formatDocumentTitle('Program chips')}</title>
      </Helmet>
      <ProgramChipsPage preselectShortCode={salon} />
    </>
  );
}
